import {styled} from '@mui/material'
import {Images, Texts} from 'appearance'
import FormTextInput from 'components/Control/Form/FormTextInput'
import {useFormContext} from 'react-hook-form'
import {useI18n} from 'store/Store'
import WizardComponentWrapper from '../WizardComponentWrapper'
import {useYupValidation} from 'services/hooks'
import {registerPasswordSetupSchema} from 'services/utils/validationsSchemas'

const PasswordSetup = ({setValidationError}) => {
    const {i18n} = useI18n()
    const formContext = useFormContext()

    const {
        control: formControl,
        formState: {errors: formErrors},
        watch,
        getValues,
    } = formContext

    const password = watch('password')
    const confirmPassword = watch('confirmPassword')

    useYupValidation(
        registerPasswordSetupSchema,
        getValues,
        [password, confirmPassword],
        setValidationError
    )

    return (
        <WizardComponentWrapper sideImage={Images.REGISTER_STEP_3}>
            <Text>{i18n.t('register.passwordSetupTitle')}</Text>

            <FormTextInput
                name="password"
                label={i18n.t('users.password')}
                control={formControl}
                rules={{
                    required: true,
                }}
                fullWidth
                type="password"
                initialValue=""
                errors={formErrors}
                height="48px"
                style={{color: '#95969A'}}
                InputProps={{style: {background: '#FAFAFA'}}}
            />
            <FormTextInput
                name="confirmPassword"
                label={i18n.t('users.confirmPassword')}
                placeholder={i18n.t('register.confirmPasswordPlaceholder')}
                control={formControl}
                rules={{
                    required: true,
                }}
                fullWidth
                type="password"
                initialValue=""
                errors={formErrors}
                height="48px"
                style={{color: '#95969A'}}
                InputProps={{style: {background: '#FAFAFA'}}}
            />
        </WizardComponentWrapper>
    )
}

export default PasswordSetup

const Text = styled(Texts.BoldText)`
    font-size: 24px;
    text-align: right;
    width: 100%;
`
